import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ENV_URL } from '../../app/constants'

const TestimonialsSwiperCard = ({ item, index, playersRef, onPlay }) => {
    const { t } = useTranslation()

    const renderStars = count => {
        return [...Array(5)].map((_, i) => (
            <i
                key={i}
                className={`bi ${
                    i < count
                        ? 'bi-star-fill text-warning'
                        : 'bi-star text-muted'
                }`}
            ></i>
        ))
    }

    useEffect(() => {
        if (item?.youtube_embed_src) {
            const id = `youtube-${index}`
            const interval = setInterval(() => {
                if (window.YT && window.YT.Player) {
                    playersRef.current[index] = new window.YT.Player(id, {
                        events: {
                            onStateChange: (event) => {
                                if (event.data === window.YT.PlayerState.PLAYING) {
                                    onPlay(index)
                                }
                            }
                        }
                    })
                    clearInterval(interval)
                }
            }, 500)
            return () => clearInterval(interval)
        }
    }, [item, index, playersRef, onPlay])

    return (
        <div className="testimonial-card p-4 text-center shadow">
            {item?.video_url && (
                <video 
                    ref={(el) => (playersRef.current[index] = el)} 
                    controls 
                    className="w-100 mb-3 rounded"
                    onPlay={() => onPlay(index)}
                >
                    <source src={item.video_url} type="video/webm" />
                    Tu navegador no soporta el video.
                </video>
            )}
            {(item?.youtube_video_url && item?.youtube_embed_src) && (
                <div className="ratio ratio-16x9 mb-3">
                    <iframe
                        id={`youtube-${index}`}
                        //width="560"
                        //height="315"
                        src={item.youtube_embed_src}
                        title="YouTube video player"
                        //frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    ></iframe>
                </div>
            )}
            {item?.audio_url && (
                <audio
                    ref={(el) => (playersRef.current[index] = el)}
                    controls
                    className="w-100 mb-3"
                    onPlay={() => onPlay(index)}
                >
                    <source src={`${item.audio_url}`} type={`audio/${item.audio_url.split('.').pop()}`} />
                    Tu navegador no soporta el audio.
                </audio>
            )}
            <>
            <div className={item.video_url !== null || item.youtube_embed_src !== null ? 'mb-2 mt-2' : 'mb-2'}>{renderStars(item.rating)}</div>
            {item?.text && <p className="fst-italic mb-3">{t(item.text)}</p>}
            {item?.image && (
                <img
                    src={item.image}
                    alt={item.name}
                    className="rounded-circle mx-auto mb-3"
                    style={{
                        width: '70px',
                        height: '70px',
                        objectFit: 'cover',
                    }}
                />
            )}
            <h6 className="fw-bold mb-0">{item.name}</h6>
            {item?.company && <i className="text-muted">{item.company}</i>}
            {item?.youtube_video_url && (
                <h6 className='mt-4'><a href={item.youtube_video_url} target='_blank' >Ver {item.youtube_embed_src ? 'video' : 'short'} en YouTube</a></h6>
            )}
            {item?.history_url && (
                <h6 className='mt-4'><a href={item.history_url} >Lee su historia aquí</a></h6>
            )}
            </>
        </div>
    )
}

export default TestimonialsSwiperCard
